import { DatabasesDisplayPlacePageData, TablesDisplayPlacePageData, UIActions } from '@tableau/data-catalog-client-components';
import { updateBreadcrumbHref } from '../../app/actions/UpdateBreadcrumbHref';
import { updateBreadcrumbs } from '../../app/actions/UpdateBreadcrumbsAction';
import { appStore } from '../../app/AppStore';
import { BreadcrumbStateInfo } from '../../app/content/breadcrumbs/BreadcrumbStateInfo';
import { ServiceLocator } from '../../app/ServiceLocator';
import { renderDatabasesActionMenu, renderTablesActionMenu } from '../../common/react/components/CatalogActionsMenu';
import { BrowserTitleService } from './BrowserTitleService';
import { ToasterService, ToastType } from './ToasterService';


export class DataCatalogUIActionsService implements UIActions {

  private static s_instance: DataCatalogUIActionsService | null = null;

  public static instance(): DataCatalogUIActionsService {
    if (!this.s_instance) {
      this.s_instance = new DataCatalogUIActionsService();
    }
    return this.s_instance;
  }

  public renderDatabasesActionMenu(database: DatabasesDisplayPlacePageData): JSX.Element {
    return renderDatabasesActionMenu(database);
  }

  public renderTablesActionMenu(table: TablesDisplayPlacePageData): JSX.Element {
    return renderTablesActionMenu(table);
  }

  public updateBreadcrumbs(breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>) {
    appStore.dispatch(updateBreadcrumbs(breadcrumbs));
  }

  public updateBreadcrumbHref(href: string) {
    appStore.dispatch(updateBreadcrumbHref(href));
  }

  public setBrowserTitleWithPlaceNameFunction(nameFunction: () => string) {
    const browserTitleService: BrowserTitleService = ServiceLocator.get('BrowserTitleService');
    browserTitleService.setTitleWithPlaceNameFunction({ placeNameFunction: nameFunction });
  }

  public setBrowserTitleWithSpaceEntityNameAndTranslatedSubspaceName(spaceEntityName: string, translatedSubspaceName: string) {
    const browserTitleService: BrowserTitleService = ServiceLocator.get('BrowserTitleService');
    browserTitleService.setTitleWithSpaceEntityNameAndTranslatedSubspaceName({ spaceEntityName, translatedSubspaceName });
  }

  public setBrowserTitleWithPlaceEntityName(name: string) {
    const browserTitleService: BrowserTitleService = ServiceLocator.get('BrowserTitleService');
    browserTitleService.setTitleWithPlaceEntityName({ placeEntityName: name });
  }

  private getToastType(type: string): ToastType {
    switch (type) {
      case 'success':
        return ToastType.Success;
      case 'info':
      return ToastType.Info;
      case 'warning':
      return ToastType.Warning;
      case 'error':
      default:
      return ToastType.Error;
    }
  }

  public popToast(type: 'success' | 'info' | 'warning' | 'error', text: string): number {
    const toasterService: ToasterService = ServiceLocator.get('ToasterService');
    const toastType: ToastType = this.getToastType(type);
    const toastId = toasterService.pop({ type: toastType, text: text });
    return toastId;
  }

  public closeToast(toastId: number) {
    const toasterService: ToasterService = ServiceLocator.get('ToasterService');
    toasterService.close(toastId);
  }

}
